export interface AuthState {
    authenticated: boolean;
    sessionToken: string;
    userId: string;
    errorMessage: string;
    isGoogleAccount: boolean;
    isGuest: boolean;
    guest?: GuestUser;
    didSignUp: boolean;
}

export interface GuestUser {
    avatar: null;
    created_at: string;
    deleted_at: string | null;
    email: string; 
    first_name: string;
    last_name: string;
    id: number;
    is_active: boolean;
    is_deleted: boolean;
    language_id: number;
    notes: null;
    updated_at: string;
}

const defaultState: AuthState = {
    authenticated: false,
    sessionToken: "",
    userId: "",
    errorMessage: "",
    isGoogleAccount: false,
    didSignUp: false,
    isGuest: false,
};

export default defaultState;
